import {
  EditTargetData,
  EditTargetOrZone,
  EditTargetZone,
} from "@shared/features/signals/EditSignal/types";
import { isEditableTargetZone } from "@shared/features/signals/common/utils";
import { meanBy } from "lodash";
import { OrderStatus } from "@shared/types";
import {
  getEditWeightedAverageEntryPrice,
  orderHasStatus,
} from "@shared/features/trades/common/utils";

export const getTargetsBreakEvenPrice = (
  targets: EditTargetOrZone[],
  isShort?: boolean
) => {
  const zone = (targets.length &&
    isEditableTargetZone(targets[0]) &&
    targets[0]) as EditTargetZone;
  if (zone) {
    if (zone.price_reached) {
      const [minPrice, maxPrice] = zone.target_price.map((price) =>
        parseFloat(price)
      );
      return isShort
        ? meanBy([minPrice, zone.price_reached])
        : meanBy([zone.price_reached, maxPrice]);
    }
    return 0;
  }
  return getEditWeightedAverageEntryPrice(
    targets.filter(
      (target) =>
        !isEditableTargetZone(target) && target.status === OrderStatus.FULFILLED
    ) as EditTargetData[]
  );
};

export const isPartiallyFulfilledZone = (
  zone: EditTargetZone | EditTargetData
): zone is EditTargetZone & { price_reached: number } => {
  const isTargetZone = isEditableTargetZone(zone);
  return (
    isTargetZone && orderHasStatus(zone, false, OrderStatus.PARTIALLY_FULFILLED)
  );
};

export const moveZoneBorderToPrice = (
  target: EditTargetZone,
  isShort: boolean,
  priceText: string
) => {
  target.edit_target_price = isShort
    ? [target.edit_target_price[0], priceText]
    : [priceText, target.edit_target_price[1]];
  updateZoneFulfilledStatus(target, isShort);
};

export const getTargetPrice = (target: EditTargetOrZone, isShort?: boolean) => {
  if (!isEditableTargetZone(target))
    return parseFloat(target.edit_target_price);

  const [min, max] = target.edit_target_price.map((price) => parseFloat(price));
  if (isShort) return max;
  return min;
};

export const updateZoneFulfilledStatus = (
  target: EditTargetOrZone,
  isShort: boolean
) => {
  if (!isPartiallyFulfilledZone(target)) {
    return;
  }

  const price = getTargetPrice(target, isShort);
  if (price !== target.price_reached) {
    target.edit_status = "Partially Fulfilled" as OrderStatus; // hopefully this will be consistent with server at one point.
    return;
  }
  target.edit_status = OrderStatus.FULFILLED;
};

export const moveZoneBorderToPriceReached = (
  target: EditTargetZone,
  isShort: boolean
) => {
  if (isPartiallyFulfilledZone(target)) {
    const priceText = target.price_reached.toString();
    moveZoneBorderToPrice(target, isShort, priceText);
  }
};
